// extracted by mini-css-extract-plugin
export default {"container":"WorkForm-module__container--ed3e"};